import {Directive, Input, OnInit, TemplateRef, ViewContainerRef} from '@angular/core';
import {AppConfigService} from '@shared/services/app-config.service';

@Directive({
  selector: '[siEnvironment]'
})
export class EnvironmentDirective implements OnInit {
  // Array of all environment names we want to check to create the element that has the environment directive.
  @Input() siEnvironment: string[];

  // Operation to apply in the environments. How to use: *siEnvironment="['environment1', 'environment2']; operation: 'or'"
  @Input() siEnvironmentOperation: string;

  // If true, the directive acts the other way around, that is, it does not create the element if the environment variable is active.
  @Input() siEnvironmentHide = false;

  constructor(
    private appConfigService: AppConfigService,
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef
  ) {
  }

  ngOnInit(): void {
    this.checkEnvironment();
  }

  checkEnvironment(): void {
    if (this.siEnvironmentOperation === 'or') {
      if (!this.siEnvironment.find(name => {
        const hasConfigurationEnabled = this.appConfigService.hasConfigurationEnabled(name);
        return this.siEnvironmentHide ? !hasConfigurationEnabled : hasConfigurationEnabled;
      })) {
        this.viewContainer.clear();
        return;
      }
    } else {
      if (!this.siEnvironment.every(name => {
        const hasConfigurationEnabled = this.appConfigService.hasConfigurationEnabled(name);
        return this.siEnvironmentHide ? !hasConfigurationEnabled : hasConfigurationEnabled;
      })) {
        this.viewContainer.clear();
        return;
      }
    }

    this.viewContainer.createEmbeddedView(this.templateRef);
  }
}
